import { RootState } from "@redux/Store";

export const AuthSelectors = Object.freeze({
    isLoggedIn: (state: RootState): boolean => {
        return !!state.auth.account && !!state.auth.accessToken && !!state.auth.refreshToken;
    },
});
